export default {"src":"/_next/static/image/public/images/waiting_queue.b57fdd0074f2dbf417bf0eaf0abb67ac.svg","height":36,"width":36};